if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.closeEvent = new CustomEvent("product:modal-close");
        this.openEvent = new CustomEvent("product:modal-open");

        // AZP-7460: touch devices have no hover zoom, so a tap on the lightbox
        // image zooms it in place and the container scrolls to pan. A mouse
        // click never gets here usefully - pointerup already closes the modal.
        this.zoomContainer = this.querySelector('[role="document"]');
        this.zoomContainer?.addEventListener("click", this.onImageTap.bind(this));
      }

      onImageTap(event) {
        const image = event.target.closest("img[data-media-id]");
        if (!image) {
          return;
        }

        const container = this.zoomContainer;
        const before = image.getBoundingClientRect();
        const ratioX = (event.clientX - before.left) / before.width;
        const ratioY = (event.clientY - before.top) / before.height;

        if (!image.classList.toggle("is-zoomed")) {
          return;
        }

        // Keep the tapped point under the finger after the image grows.
        const after = image.getBoundingClientRect();
        container.scrollLeft += after.left + ratioX * after.width - event.clientX;
        container.scrollTop += after.top + ratioY * after.height - event.clientY;
      }

      resetZoom() {
        this.querySelectorAll("img.is-zoomed").forEach((image) => {
          image.classList.remove("is-zoomed");
        });
      }

      hide() {
        super.hide();
        document.dispatchEvent(this.closeEvent);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.dispatchEvent(this.openEvent);
      }

      showActiveMedia() {
        this.resetZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`,
        ).forEach((element) => {
          element.classList.remove("is-active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add("is-active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        ) {
          activeMedia.loadContent();
        }
      }
    },
  );
}
